import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getFormSyncErrors, getFormValues} from "redux-form";
import {toastr} from 'react-redux-toastr';
import moment from 'moment';
import * as courseActions from '../../actions/courseActions';
import * as courseCategoryActions from '../../actions/courseCategoryActions';
import * as courseTypesActions from '../../actions/courseTypeActions';
import * as contactPersonListActions from '../../actions/contactPersonListActions';
import * as contactPersonModalActions from '../../actions/contactPersonModalActions';
import * as regionActions from "../../actions/regionActions";
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import * as companyRegionsActions from '../../actions/companyRegionsActions';
import * as countryActions from '../../actions/countryActions';
import * as companyMunicipalityActions from '../../actions/companyMunicipalityActions';
import * as vimeoActions from '../../actions/vimeoActions';
import * as modalActions from '../../actions/common/modalActions';
import ContactPersonModal from '../contact-person/ContactPersonModal';
import CourseFormRedux from "./CoursesFormRedux";
import CoursesParamsFormatter from "../../services/CoursesParamsFormatter";
import ReactSelectFormatter from "../../services/ReactSelectFormatter";
import {DATE_TIME_FORMAT} from "../../components/helpers/DateHelper";
import CompanyInformationSelector from "../../reducers/company/CompanyInformationSelector";
import { FormattedMessage, injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import _ from 'lodash';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from "../ResetFormModal";

class CoursesFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.submit = this.submit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.onModalClick = this.onModalClick.bind(this);

        this.state = {
            uploadedImages: [],
        };

        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [
            this.props.actions.loadCourseCategories(this.props.user.company.portalId),
            this.props.actions.loadContactPersons(this.props.user.company.id),
            this.props.actions.loadCourseTypes(),
            this.props.actions.loadCountries(),
            this.props.actions.loadCompanyRegions(),
            this.props.actions.loadCompanyMunicipalities(),
        ];


        if (this.isUpdate()) {
            actions.push(this.props.actions.getCourse(this.props.match.params.id));
        } else {
            actions.push(this.props.actions.resetCourse());
        }

        return actions;
    }

    submit(formFields) {
        if(formFields.vimeoId) {
            this.props.actions.updateVimeoVideo(formFields.vimeoId, {name: formFields.vimeoName || formFields.heading, description: formFields.vimeoDescription})
                .then(() => {
                    this.sendForm(formFields);
                });
        } else {
            this.sendForm(formFields);
        }
    }

    sendForm(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        let params = CoursesParamsFormatter.format(formFields, this.props.user.id);
        if (this.isUpdate()) {
            this.props.actions.updateCourse(params).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.courseUpdated));
                this.props.actions.clearCourseList();
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        } else {
            this.props.actions.saveCourse(params).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.courseCreated));
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        }
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    componentWillReceiveProps(nextProp) {
        if(
            nextProp.formValues.vimeoId !== '' &&
            this.props.formValues.vimeoId !== nextProp.formValues.vimeoId &&
            this.props.match.params.id
        ) {
            let vimeoId = nextProp.formValues.vimeoId;
            this.props.actions.updateCourseVimeo(this.props.match.params.id, {vimeoId});
        }

        this.setState({selectedCategories: this.props.course.categoryIds});

        if(!_.isEqual(nextProp.course.categories, this.props.course.categories)) {
            this.setState({selectedCategories: nextProp.course.categoryIds});
        }
    }

    onModalClick() {
        this.props.actions.showContactPersonModal();
    }

    redirect() {
        this.context.router.history.push('/kurser')
    }

    render() {
        let {
            countries,
            regions,
            municipalities,
            addressSearchResult,
            user,
            course,
            contactPersons,
            categories,
            types,
        } = this.props;

        if (user.id === undefined) {
            return null;
        }
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">{this.props.intl.formatMessage(messages.courseFormTitle)}</h1>
                                <CourseFormRedux
                                    initialValues={course}
                                    onSubmit={this.submit}
                                    contactPersons={contactPersons}
                                    categories={categories}
                                    types={types}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                    handleModalClick={this.onModalClick}
                                    handleReset={this.handleReset}
                                    isUpdate={this.isUpdate()}
                                    countries={countries}
                                    regions={regions}
                                    municipalities={municipalities}
                                    addressSearchResult={addressSearchResult}
                                />
                                <ContactPersonModal userId={user.company.id}/>
                            </div>
                        </div>
                    </div>
                </div>
                <ResetFormModal
                    modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                    modalContent={
                        <p>
                            <FormattedMessage
                                id="reset.modal.message"
                                defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                            />
                        </p>}
                    confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                    closeText={this.props.intl.formatMessage(messages.buttonNo)}
                    handleConfirm={() => {this.confirmReset()}}
                />
            </div>
            </WithResolvedPromises>
        );
    }
}

CoursesFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let course = CoursesParamsFormatter.convertToForm(state.course);
    let errors = Object.assign({}, getFormSyncErrors('course')(state));
    let formValues = Object.assign({}, getFormValues('courses')(state));

    let categories = [];

    if (state.courseCategories.length !== 0) {
        categories = ReactSelectFormatter.formatCourseCategories(state.courseCategories);
    }

    let regions = CompanyInformationSelector.fillSelects(state.companyRegions, 'regions');
    let municipalities = Array.from(state.companyMunicipalities);
    municipalities = CompanyInformationSelector.filterMunicipalitiesByRegion(municipalities, course.regionId);

    municipalities = CompanyInformationSelector.fillSelects(municipalities, 'municipalities');
    let addressSearchResult = CompanyInformationSelector.fillSelects(state.addressSearchResults, 'addresses');

    return {
        course: course,
        regions: regions,
        municipalities: municipalities,
        addressSearchResult,
        contactPersons: state.contactPersons,
        categories: categories,
        types: state.courseTypes,
        user: state.user,
        errors: errors,
        formValues: formValues,
        countries: state.countries,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                courseActions,
                courseCategoryActions,
                courseTypesActions,
                contactPersonListActions,
                contactPersonModalActions,
                regionActions,
                companyRegionsActions,
                countryActions,
                companyMunicipalityActions,
                submitButtonActions,
                vimeoActions,
                modalActions
            ), dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CoursesFormContainer));





// WEBPACK FOOTER //
// ./web/src/components/venues-and-courses/CoursesFormContainer.jsx